
class TabbedCollection extends HTMLElement {
	constructor() {
		super()

		this.tabButtons = this.querySelectorAll(".tab-navigation .tab_label") || []
		this.components = this.querySelectorAll(".tab-content .slideshow") || []

		if (this.tabButtons.length === 0 || this.components.length === 0) {
			console.warn("Tabs not found")
			return
		}

		this.tabButtons.forEach((button, index) => {
			button.addEventListener("click", () => {
				this.tabButtons.forEach(btn => btn.classList.remove("active"))
				this.components.forEach(ele => ele.classList.add("hidden"))

				button.classList.add("active")
				this.components[index].classList.remove("hidden")
			})
		})
	}
}

customElements.define("tabbed-collection", TabbedCollection)
